export const environment = {
  production: false,
  staging: false,
  uat: true,
  isHallNavEnabled: true,
  isViewStallsEnabled: true,
  base_url: "https://apiuat.akosh.in",
  selfcare_url: "https://selfcareuat.akosh.in",
  web_url: "https://webuat.akosh.in/",
  api_prefix: "cms/api",
  web_view_api_prefix: "api",
  x_api_key: "KRv2cvw3uZ1ifn4rZbO8R7f01VzciCR73jdGCbXy",
  web_view_x_api_key: "oyHK73HifF4FYkzcVvplv6r2dLaT6CeJ9QZWJXDB",
  google_translate_key: "AIzaSyDUWuWoqaru7QQOMm-yuNetlzvzPyAeIRk",
  lang_remote_config: "language_selector_staging",
  bhashini_api_creds: {
    authorization_token:
      "1M569xUGsgDNmFmb9SIx_mmGMtv-b8AnHt1AOB_U8fUS9_2wYenbGtosytBjDzHM",
    pipeline_id: "64392f96daac500b55c543cd",
    ulca_api_key: "21c0e9ba8a-1abc-4241-9461-ea6120851213",
    user_id: "a92208ee87ae4d6b87a39183ff2a2032",
  },
  base_href: "/",
};
